export default {
  get() {
    const {showRecommendations, onlyPreviouslyUsed, search} = this.value
    return {showRecommendations, onlyPreviouslyUsed, search}
  },
  set(model) {
    this.$emit('input', {...this.value, ...model})
  },
}
